import type { LanguageCodeEnum } from '@boc/framework/saleor-graphql';

export const DEFAULT_LOCALE = 'en';

export const supportedLocales = ['en'];

export const localeMapping: Record<string, LanguageCodeEnum> = {
  en: 'EN',
};
